// -------------------------------------
//  gnav(~768)
// -------------------------------------
export default function Gnav(){
  $('.l-headerToggle').on('click',function(){
    if($('.l-header').hasClass('is-openSp')){
      $('.l-header').removeClass('is-openSp');
    }else{
      $('.l-header').addClass('is-openSp');
    }
  });
  $('.l-headerOverlay').on('click', function(){
    $('.l-header').removeClass('is-openSp');
  });
  $(window).on('resize orientationchange',function(){
    if (window.matchMedia('screen and (min-width:768px)').matches) {
      $('.l-header').removeClass('is-openSp');
    }
  });
}
